import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function GeneralReportManage ( props ) {

    return <BasicCrudScreenType id="GeneralReportManage" noExcel table="GeneralReport" view="GeneralReport"   />

}

export default GeneralReportManage;